"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../../../../styles");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    listItemTextontainer: {
        wordBreak: 'break-all'
    }
}); });
exports.default = useStyles;
